module.exports = __webpack_public_path__ + "static/img/exploit16.53bdff79.png";